"use strict";
module.exports = {
    'v1.shopUser.registerWithNewCustomerSubUnit': 'endCustomerGateway',
    'v1.shopUser.registerWithExistingCustomerSubUnit': 'endCustomerGateway',
    'v1.shopUser.registerWithNewSupplierCustomer': 'endCustomerGateway',
    'v1.shopUser.registerWithExistingSupplierCustomer': 'endCustomerGateway',
    'v1.shopUser.registerThroughInvite': 'endCustomerGateway',
    'v1.shopUser.login': 'endCustomerGateway',
    'v1.shopUser.changeActiveMembership': 'endCustomerGateway',
    'v1.shopUser.me': 'endCustomerGateway',
    'v1.shopUser.restaurantReport': 'endCustomerGateway',
    'v1.shopUser.changePassword': 'endCustomerGateway',
    'v1.shopUser.sendForgotPasswordLink': 'endCustomerGateway',
    'v1.shopUser.restorePassword': 'endCustomerGateway',
    'v1.shopUser.validatePasswordToken': 'endCustomerGateway',
    'v1.shopUser.updateMe': 'endCustomerGateway',
    'v1.shopUser.writeShopUser': 'endCustomerGateway',
    'v1.shopUser.approve': 'endCustomerGateway',
    'v1.shopUser.disapprove': 'endCustomerGateway',
    'v1.shopUser.verifyEmail': 'endCustomerGateway',
    'v1.shopUser.activate': 'endCustomerGateway',
    'v1.shopUser.deactivate': 'endCustomerGateway',
    'v1.shopUser.changeCustomer': 'endCustomerGateway',
    'v1.shopUser.getCustomerForSessionUser': 'endCustomerGateway',
    'v1.shopUser.upsert': 'endCustomerGateway',
    'v1.shopUser.upsertWhenEmpty': 'endCustomerGateway',
    'v1.shopUser.updateWhenEmpty': 'endCustomerGateway',
    'v1.shopUser.update': 'endCustomerGateway',
    'v1.invite.sendCustomerSubUnitInvite': 'endCustomerGateway',
    'v1.invite.sendSupplierCustomerInvite': 'endCustomerGateway',
    'v1.invite.sendPurchasingInvite': 'endCustomerGateway',
    'v1.invite.accept': 'endCustomerGateway',
    'v1.invite.upsert': 'endCustomerGateway',
    'v1.invite.upsertWhenEmpty': 'endCustomerGateway',
    'v1.invite.updateWhenEmpty': 'endCustomerGateway',
    'v1.invite.update': 'endCustomerGateway',
    'v1.endCustomerOrganization.addShopUser': 'endCustomerGateway',
    'v1.endCustomerOrganization.upsert': 'endCustomerGateway',
    'v1.endCustomerOrganization.upsertWhenEmpty': 'endCustomerGateway',
    'v1.endCustomerOrganization.updateWhenEmpty': 'endCustomerGateway',
    'v1.endCustomerOrganization.update': 'endCustomerGateway',
    'v1.end-customer-gatewayEventsource.cleanUpOldEvents': 'endCustomerGateway',
    'v1.end-customer-gatewayEventsource.undoEvent': 'endCustomerGateway',
    'v1.end-customer-gatewayEventsource.reEmit': 'endCustomerGateway',
};
